import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  public translateMessage!: string;
  public translateMessageDescription: string;
  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, private oauthService: OAuthService) { }

  ngOnInit(): void {
  }

  closeDialog(){
    this.dialogRef.close(false);
  }
}
